import { shallowEqual, useDispatch } from "react-redux";
import { AssetsPng } from "../../assets/png";
import { DefaultImageType } from "../../configs/appConstants";
import { ActionUi, useAppSelector, VRIAppStateType} from "../../core";

export function useFunctionalityImageView() {
  const dispatch = useDispatch();
  const imageView = useAppSelector(
    (state: VRIAppStateType) => ({
      fileTimeStamp:state.ui.fileTimeStamp
    }),
    shallowEqual
  );
const defaultImageLoad = (event: any,type:DefaultImageType,imageCondition?:string) => {
    imageCondition = imageCondition || '';
      let src="";
      if(type==DefaultImageType.UserProfile)
      {
         src = "/assets/images/png/user-silhouette.png";
      }
      else if(type==DefaultImageType.SideNavProfile)
      {
           src = "/assets/images/png/user-silhouette.png";
      }
      else if(type==DefaultImageType.DefaultProfile)
      {
          src=`https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg${imageCondition}`;
      }
      else if(type==DefaultImageType.CompanyProfile)
      {
          src="/assets/images/png/companyImg.png"
      }
      else if(type==DefaultImageType.DefaultCompanyProfile){

        src="/assets/images/png/defaultCompanyImage.png"
      }
      else if(type==DefaultImageType.DefaultChat){
        src="/assets/images/png/chatDefault.png"
      }
    event.target.src =src;
      
  };
  const onUploadComplete = () => {
    dispatch(ActionUi.SetFileTimeStamp(Date.now()));
  };
  return{
    onUploadComplete,
      imageView,
      defaultImageLoad
  }
}
